<template>
  <div>
    <present-levels-goal-recommendations/>
  </div>
</template>

<script>
import PresentLevelsGoalRecommendations from '@/components/presentlevels/PresentLevelsGoalRecommendations'
import { mapState } from 'vuex'

export default {
  name: 'PresentLevelsConclusionAssessments',
  components: {
    PresentLevelsGoalRecommendations
},
    computed: {
        ...mapState('presentlevels', {
            resources: state => state.resourceDocs,
        })
    }
}
</script>
